import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  return (
    <section className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-8">
        <div className="text-center">
          <p className="flex items-center justify-center gap-2 text-xs font-semibold tracking-[0.25em] text-primary-600 md:text-sm">
            <i className="ri-question-line"></i>
            FAQ
          </p>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">常见问题</h2>
        </div>

        <div className="mt-10 flex flex-col divide-y divide-background-200 border-y border-background-200">
          {faqs.map((item) => (
            <div key={item.id} className="py-6">
              <h3 className="flex items-start gap-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                <i className="ri-circle-fill mt-1.5 text-[6px] text-primary-500"></i>
                {item.question}
              </h3>
              <p className="mt-3 pl-5 text-sm leading-loose text-foreground-600">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}